export default __webpack_public_path__ + "static/media/cargills.9edeb719.png";